import React, { useEffect } from 'react';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import { StyleSheet } from 'react-native';
import { ThemeProvider } from './theme/useTheme';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { NavigationContainer } from '@react-navigation/native';
import MainNavigator from './routes/Navigator';
import { linking } from './routes/linking';

import { GrowthBookProvider } from '@growthbook/growthbook-react';
import store, { persistor } from './store/store';
import growthbook from './config/GrowthBook';

// Import driver.js CSS for user tours
import 'driver.js/dist/driver.css';

const App: React.FC = () => {
  // GrowthBook streaming/init is called here.
  // To avoid network calls and analytics in local dev, you can guard this with NODE_ENV.
  // See GrowthBook.tsx for config details.
  useEffect(() => {
    growthbook.init({ streaming: true });
  }, []);

  return (
    // 3. Wrap your app in the GrowthBookProvider
    <GrowthBookProvider growthbook={growthbook}>
      <SafeAreaProvider>
        <SafeAreaView style={styles.appContainer}>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <ThemeProvider>
                <NavigationContainer linking={linking}>
                  <MainNavigator />
                </NavigationContainer>
              </ThemeProvider>
            </PersistGate>
          </Provider>
        </SafeAreaView>
      </SafeAreaProvider>
    </GrowthBookProvider>
  );
};

const styles = StyleSheet.create({
  appContainer: {
    flex: 1,
  },
});

export default App;
